import React, { Component } from 'react';
import { options } from './keys';
import { flattenChildren, getParents } from './helpers';

class Sidebar extends Component {
    constructor(props) {
        super();

        this.onSelect = this.onSelect.bind(this);

        this.domainId = props.domain_id || props.default_domain_id;
        this.options = options({ domainId: this.domainId, hasCommerce: props.has_commerce });

        this.state = {
            selectedIds: [],
            defaultSelected: [],
        };
    }

    componentDidMount() {
        const all = flattenChildren(this.options);
        const selectedItem = all.find((item) => {
            if (item.hrefStartsWith)
                return window.location?.pathname.startsWith(item.hrefStartsWith);

            if (item.pathnames) return item.pathnames.includes(window.location?.pathname);

            return item.href === window.location?.pathname;
        });
        const parents = getParents(all, selectedItem);
        const reversed = parents.reverse();
        if (selectedItem)
            this.setState({
                selectedIds: [...reversed, selectedItem.id],
                defaultSelected: [...reversed, selectedItem.id],
                selectedUrl: selectedItem.id,
            });
    }

    onSelect(id, { clearAllSelected }) {
        if (clearAllSelected) {
            const ids = this.state.selectedIds.includes(id) ? [] : [id];
            return this.setState({
                selectedIds: ids,
            });
        }
        const ids = this.state.selectedIds.includes(id)
            ? this.state.selectedIds.filter((item) => item !== id)
            : [this.state.selectedIds[0], id];

        this.setState({
            selectedIds: ids,
        });
    }

    collectData(options) {
        return options.map(
            (item) =>
                !item.isHidden && (
                    <React.Fragment key={item.id}>
                        {item.href && (
                            <button
                                title={item.title}
                                className={`list-group-item discovery-item  ${
                                    this.state.selectedUrl === item.id
                                        ? 'default-selected-item'
                                        : ''
                                }`}
                            >
                                <a href={item.href}>
                                    {item.icon && <i className={item.icon}></i>}
                                    <span className="collaps-btn sidebar-item-title">
                                        {item.title}
                                    </span>
                                </a>
                            </button>
                        )}
                        {item.collapsTargetId && (
                            <div id={item.id}>
                                <button
                                    className={`collapsed list-group-item discovery-item panel-heading ${
                                        this.state.selectedIds.includes(item.id) ? 'active' : ''
                                    }`}
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#${item.collapsTargetId}`}
                                    aria-expanded="false"
                                    aria-controls={item.collapsTargetId}
                                    onClick={() => this.onSelect(item.id, item)}
                                    title={item.title}
                                >
                                    <span className="collaps-btn">
                                        {item.icon && <i className={item.icon}></i>}
                                        <span className="sidebar-item-title">{item.title}</span>
                                    </span>
                                </button>
                                <div
                                    id={item.collapsTargetId}
                                    className={`collapse panel-collapse ${
                                        this.state.defaultSelected.includes(item.id) ? 'show' : ''
                                    }`}
                                    aria-labelledby="headingTwo"
                                    data-bs-parent={`#${item.parent ?? 'accordion'}`}
                                >
                                    <div className="pl-20">{this.collectData(item.children)}</div>
                                </div>
                            </div>
                        )}
                    </React.Fragment>
                ),
        );
    }

    render() {
        return (
            <div id="accordion">
                {this.collectData(this.options)}
                <div className="sidebar-bottom">
                    <button
                        className="btn-icon mini-menu-toggle-btn"
                        onClick={() => this.props.updateStyle('mini-menu')}
                    >
                        <i className="icon-chevron-left-double" />
                    </button>
                    <button
                        className="btn-icon"
                        onClick={() => this.props.updateStyle('menu-version')}
                    >
                        <i className="icon-u_top-arrow-to-top-path2" />
                    </button>
                </div>
            </div>
        );
    }
}

export default Sidebar;
